import agentManages from './agentManages'
import agAgentManage from './agAgentManage'
import agAgencyManage from './agAgencyManage'
import agRakeBackManage from './agRakeBackManage'
import agentAccount from './agentAccount'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...agentManages,
      ...agAgentManage,
      ...agAgencyManage,
      ...agRakeBackManage,
      ...agentAccount
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/agentManage/index.js